module.exports = __webpack_public_path__ + "img/1-5.04db9434.png";